export default __webpack_public_path__ + "static/media/eyeopen.4e12116d.svg";